import {Injectable} from '@angular/core';
import {User} from '../../data/models/user';
import {Privilege} from '../../data/models/privilege';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import { TestExecution } from '../../data/models/execution/test-execution';

@Injectable({
  providedIn: 'root'
})
export class MeService {

  private meSubject = new BehaviorSubject<User | null>(null);
  private privilegesSubject = new BehaviorSubject<Privilege[]>([]);

  constructor(
    private http: HttpClient,
  ) {
  }

  public get me$(): Observable<User | null> {
    return this.meSubject.asObservable();
  }

  public get me(): User | null {
    return this.meSubject.getValue();
  }

  public get privileges$(): Observable<Privilege[]> {
    return this.privilegesSubject.asObservable();
  }

  hasPrivilege(privilege: string): boolean {
    const privileges = this.privilegesSubject.getValue();
    return Boolean(privileges && privileges.find(p => p.techId === privilege));
  }

  fetchMe(): Promise<User> {
    return this.http.get<User>('api/me')
      .toPromise()
      .then(me => {
        if (me) {
          this.meSubject.next(me);
          return me;
        } else {
          this.unsetMe();
          throw new Error();
        }
      })
      .catch(error => {
        this.unsetMe();
        throw error;
      });
  }

  fetchPrivileges(): Promise<Privilege[]> {
    return this.http.get<Privilege[]>('api/me/privileges')
      .toPromise()
      .then(privileges => {
        this.privilegesSubject.next(privileges);
        return privileges;
      });
  }

  fetchAll(): Promise<void> {
    return this.fetchMe()
      .then(() => this.fetchPrivileges())
      .then(() => {
      })
      .catch(error => this.unsetMe());
  }

  unsetMe(): void {
    this.meSubject.next(null);
    this.privilegesSubject.next([]);
  }

  startTestExecution(urlCode: string, studentName: string, studentMail: string): Promise<TestExecution> {
    const formData = new FormData();
    formData.append('urlCode', urlCode);
    formData.append('studentName', 'Anonymous');
    formData.append('studentMail', 'anonymous@example.com');

    return this.http.post<TestExecution>('/api/test-executions', formData)
      .toPromise()
      .then(execution => {
        console.log('Anonymous test execution started:', execution);
        return execution;
      });
  }

  startAnonymousTest(testId: number, urlCode: string): Promise<TestExecution> {
    const formData = new FormData();
    formData.append('urlCode', urlCode);
    formData.append('studentName', 'Anonymous');
    formData.append('studentMail', 'anonymous@example.com');

    return this.http.post<TestExecution>('/api/test-executions', formData)
      .toPromise()
      .then(execution => {
        console.log('Anonymous test execution started:', execution);
        return execution;
      });
  }

  changePassword(currentPassword: string, newPassword: string): Promise<User> {

    const formData = new FormData();
    formData.append('currentPassword', currentPassword);
    formData.append('password', newPassword);

    return this.http.post<User>(`api/me/actions/change-password`, formData)
      .toPromise()
      .then(me => {
        this.meSubject.next(me);
        return me;
      });
  }

}
